(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["illesa-product-purchase"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   ILLESA – Bloc produit & achat
   Le sélecteur d'offres NE crée PAS de logique panier/variante parallèle :
   il pilote les composants natifs Minimog (variant-picker, quantity input,
   product-form). Implémenté en custom element => réinitialisation propre à
   chaque shopify:section:load, aucun listener dupliqué.
   ========================================================================== */
(function () {
  "use strict";

  if (!window.customElements) return;

  /* ---------- Sélecteur d'offres ---------- */
  if (!customElements.get("illesa-offer-selector")) {
    class IllesaOfferSelector extends HTMLElement {
      connectedCallback() {
        this.section = this.closest("[data-section-id]");
        this.sectionId = this.section ? this.section.dataset.sectionId : null;
        this.productId = this.dataset.productId;
        this.inputs = Array.from(this.querySelectorAll(".illesa-offer__input"));
        if (!this.inputs.length) return;

        this.onChange = this.onChange.bind(this);
        this.addEventListener("change", this.onChange);

        // Applique l'offre déjà cochée (défaut ou première) au chargement.
        const checked = this.inputs.find((i) => i.checked && !i.disabled);
        const initial = checked || this.inputs.find((i) => !i.disabled);
        if (initial) {
          if (!initial.checked) initial.checked = true;
          // Laisse le thème finir de s'initialiser (variant-picker, qty input).
          requestAnimationFrame(() => this.applyOffer(initial));
        }
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.onChange);
      }

      onChange(evt) {
        const input = evt.target.closest(".illesa-offer__input");
        if (!input || input.disabled) return;
        this.applyOffer(input);
      }

      applyOffer(input) {
        const variantId = input.dataset.offerVariantId;
        const quantity = parseInt(input.dataset.offerQuantity, 10) || 1;

        if (variantId) this.selectVariant(variantId);
        this.setQuantity(quantity);
        this.updateCtaPrice(input);
        this.updateAria(input);
      }

      /* Pilote le variant-picker natif (ou, à défaut, les inputs id). */
      selectVariant(variantId) {
        const products = window._themeProducts || {};
        const data = products[this.productId];
        if (!data || !Array.isArray(data.variants)) return;

        const variant = data.variants.find(
          (v) => String(v.id) === String(variantId)
        );
        if (!variant) return;

        const picker = this.section && this.section.querySelector("variant-picker");
        if (picker && Array.isArray(variant.options)) {
          const fields = picker.querySelectorAll("[data-picker-field]");
          fields.forEach((field, index) => {
            const value = variant.options[index];
            if (value == null) return;
            if (field.dataset.pickerField === "radio") {
              const radios = field.querySelectorAll('input[type="radio"]');
              radios.forEach((radio) => {
                radio.checked = radio.value === value;
              });
            } else {
              const select = field.querySelector("select");
              if (select) select.value = value;
            }
          });
          // Événement natif => met à jour prix, média, disponibilité, [name=id].
          picker.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (this.section) {
          // Produit à variante unique : pas de picker, on force l'id.
          this.section.querySelectorAll('[name="id"]').forEach((i) => {
            i.value = variant.id;
          });
        }
      }

      /* Met à jour l'input quantité natif du formulaire produit. */
      setQuantity(qty) {
        if (!this.section) return;
        const scoped = this.section.querySelector(
          '[name="quantity"][form="product-form-' + this.sectionId + '"]'
        );
        const input =
          scoped ||
          this.section.querySelector(".m-quantity__input") ||
          this.section.querySelector('[name="quantity"]');
        if (!input) return;
        if (String(input.value) === String(qty)) return;
        input.value = qty;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      /* Recopie le prix pré-calculé (Liquid) de l'offre dans le CTA. */
      updateCtaPrice(input) {
        if (!this.section) return;
        const total = input.dataset.offerTotal || "";
        this.section
          .querySelectorAll("[data-illesa-cta-price]")
          .forEach((el) => {
            el.textContent = total;
          });
      }

      updateAria(current) {
        this.inputs.forEach((input) => {
          input.setAttribute("aria-checked", input === current ? "true" : "false");
        });
      }
    }
    customElements.define("illesa-offer-selector", IllesaOfferSelector);
  }

  /* ---------- « Lire la suite » de la description ---------- */
  if (!customElements.get("illesa-readmore")) {
    class IllesaReadMore extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector("[data-illesa-desc]");
        this.button = this.querySelector("[data-illesa-readmore]");
        if (!this.text || !this.button) return;
        this.expanded = false;
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener("click", this.onClick);
        // Masque le bouton si le texte n'est pas réellement tronqué.
        requestAnimationFrame(() => {
          if (this.text.scrollHeight <= this.text.clientHeight + 1) {
            this.button.style.display = "none";
          }
        });
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.onClick);
      }
      onClick() {
        this.expanded = !this.expanded;
        this.text.classList.toggle("is-clamped", !this.expanded);
        var moreLabel = this.button.dataset.more || this.button.textContent;
        var lessLabel = this.button.dataset.less || moreLabel;
        this.button.textContent = this.expanded ? lessLabel : moreLabel;
        this.button.setAttribute("aria-expanded", String(this.expanded));
      }
    }
    customElements.define("illesa-readmore", IllesaReadMore);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
